import { createElement } from 'react';

var component = function component(props) {
  return createElement("svg", Object.assign({
    viewBox: '0 0 24 24',
    xmlns: 'http://www.w3.org/2000/svg'
  }, props), createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M3.567 1.333h16.762a2.286 2.286 0 0 1 2.286 2.286v16.762a2.286 2.286 0 0 1-2.286 2.286H3.567a2.286 2.286 0 0 1-2.286-2.286V3.619a2.286 2.286 0 0 1 2.286-2.286ZM14.981 4H13v11a3 3 0 1 1-3-3v-2a5 5 0 1 0 5 5V8.171C15.93 9.186 17.247 10 19 10V8c-1.203 0-2.105-.611-2.785-1.488-.694-.895-1.091-1.797-1.234-2.512Z'
  }));
};

export { component };
//# sourceMappingURL=ItTiktokSquare-1b8adca7.js.map
